import '../wdyr'
import ReactDOM from 'react-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './Store'
import { setAuthToken } from 'Actions/user'
import { setCurrentProject } from 'Actions/projects'
import { setUserMode } from 'Actions/user'
import App from './App'
import { ErrorBoundary, Loading } from 'Components'
import 'antd/dist/antd.less'

Promise.config({
    warnings: {
        wForgottenReturn: false
    }
});

cypressPopulateReducerFunctions =
  cy_authToken: setAuthToken
  cy_currenProject: setCurrentProject
  cy_userMode: setUserMode

_.keys(localStorage).filter((key) -> key.startsWith('cy_')).map((key) ->
  store.dispatch(
    cypressPopulateReducerFunctions[key](localStorage.getItem(key))
  )
  localStorage.removeItem(key)
)

queryClient = new QueryClient()

if module.hot
  module.hot.accept('./App', ->
    NextApp = require('./App').default
    nextReducer = require('Reducers').default
    store.replaceReducer(nextReducer)

    ReactDOM.render(
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <Provider store={ store }>
            <PersistGate loading={<Loading />} persistor={persistor}>
              <NextApp />
            </PersistGate>
          </Provider>
        </QueryClientProvider>
      </ErrorBoundary>
      , document.getElementById('app'))
  )

ReactDOM.render(
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <Provider store={ store }>
        <PersistGate loading={<Loading />} persistor={persistor}>
          <App/>
        </PersistGate>
      </Provider>
    </QueryClientProvider>
  </ErrorBoundary>
  , document.getElementById('app'))
